<template>
  <DefaultPageContainer
    :cnc-ads-page="cncAdsPage"
    :breadcrumb-text="$t('newsletter_confirmation.breadcrumbs')"
  >
    <section class="section lg:w-10/12 mx-auto min-h-[50vh] grid place-items-center">

      <div class="flex items-center justify-center flex-col gap-6 pb-40">

        <DefaultIconsCheck class="newsletter-subscribe-form__messages-icon" />
        <!-- title -->

        <div class="text-center">
          <h3 class="h3" v-html="$t('newsletter_confirmation.title')"/>

          <!-- Content -->
          <div v-if="email" class="pt-2"
               v-html="$t('newsletter_confirmation.perex', {email})"
          />
          <div v-else class="pt-2"
               v-html="$t('newsletter_confirmation.perex_fixed')"
          />
        </div>
        <div class="flex items-center gap-2">
          <NuxtLink class="btn btn--back" to="/">
            {{ $t('newsletter_confirmation.homepage_btn') }}
            <DefaultIconsChevronRight/>
          </NuxtLink>
        </div>
      </div>

    </section>
  </DefaultPageContainer>
</template>

<script setup lang="ts">
import {CncAdsPage} from "~/libs/constants/CncAdsPage"
import {useI18n} from "vue-i18n"
import {useHtmlToPlainText} from "~/composables/useHtmlToPlainText"

// i18n routing
definePageMeta({
  name: 'newsletter-confirmation',
})
false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    cs: '/newsletter/confirmation',
    en: '/newsletter/confirmation'
  }
})

const config = useRuntimeConfig()
const route = useRoute()
const {t} = useI18n()
const cncAdsPage = CncAdsPage.NEWSLETTER_CONFIRMATION

const email = route.query.email

// Set SEO meta
useSeoWrapper().setSeoMeta({
  title: useHtmlToPlainText(t('newsletter_confirmation.title')),
})

/**
 * On mounted - load data client
 */
onMounted(async () => {
  /**
   * CncAds Page change
   */
  useCncAdsWrapper().changePageAds(cncAdsPage, {
    route: route
  })

})
</script>
